/**
 * Program: regex directive
 * Author: SDL
 * Description: Constraint through Regular Equation
 */
/* eslint-disable no-unused-vars */
export default {
  bind(el, binding, vnode) {
    // console.log('bind', el, binding, vnode);
    console.log(binding.value);
    el.addEventListener('keyup', () => {
      const regex = new RegExp(binding.value);
      if (!regex.test(el.value)) {
        el.value = el.value.slice(0, -1);
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/directives/regex.js